// import { getLocalUser } from '@/services/session-data';
// import { USER_TYPE_DOCTOR } from './users';

// function isVisibleForDoctor(): boolean {
//   let retorno: boolean = true;
//   getLocalUser().subscribe((data) => {
//     if (!!data) {
//       // Se for médico, status não será visível
//       if (data.tipoLogin === USER_TYPE_DOCTOR) {
//         retorno = false;
//       }
//     }
//   });
//   return retorno;
// }

export const WAITING_CLIENT = {
  key: 'AGUARDANDO_APROVACAO_CLIENTE',
  color: '#FDB833',
  icon: 'fa-business-time',
  description: 'Aguardando Aprovação Cliente',
  showInFilter: true,
};

export const WAITING_EMEDE = {
  key: 'AGUARDANDO_APROVACAO',
  color: '#07a8c5',
  icon: 'fa-user-clock',
  description: 'Aguardando Aprovação',
  showInFilter: true,
};

export const LOCKED = {
  key: 'BLOQUEADA',
  color: '#ff9800',
  icon: 'fa-lock',
  description: 'Pendente de Avaliação Interna',
  showInFilter: true,
};

export const WAITING_PHARMACEUTICAL_APPROVE = {
  key: 'AGUARDANDO_APROVACAO_FARMACEUTICA',
  color: '#c9d68c',
  icon: 'fa-check-double',
  description: 'Aguardando Aprovação da Farmacêutica',
  showInFilter: true,
};

export const WAITING_TRANSCRIPTION = {
  key: 'AGUARDANDO_TRANSCRICAO',
  color: '#9AD1D4',
  icon: 'fa-hourglass-half',
  description: 'Aguardando Transcrição',
  showInFilter: true,
};

export const CHECKED_TRANSCRIPTION = {
  key: 'CONFERIDA',
  color: '#cccccc',
  icon: 'fa-check',
  description: 'Transcrição confere a relevante',
  showInFilter: true,
};

export const SENDING_TO_PRODUCTION = {
  key: 'ENVIANDO_PRODUCAO',
  color: 'green',
  icon: 'fa-clipboard-check',
  description: 'Enviando para Produção...',
  showInFilter: true,
};

export const SENT_PARTIAL_TO_PRODUCTION = {
  key: 'EM_PRODUCAO_PARCIAL',
  color: 'green',
  icon: 'fa-clipboard-check',
  description: 'Enviado para Produção (Parcial)',
  showInFilter: true,
  class: 'status-partial-prod'
};

export const SENT_TO_PRODUCTION = {
  key: 'EM_PRODUCAO',
  color: 'green',
  icon: 'fa-clipboard-check',
  description: 'Enviado para Produção',
  showInFilter: true,
};

export const CANCELED_IN_PRODUCTION = {
  key: 'CANCELADA_NA_PRODUCAO',
  color: 'red',
  icon: 'fa-rectangle-xmark',
  description: 'Cancelada na Produção',
  showInFilter: true,
};

export const SCHEDULED_PRODUCTION = {
  key: 'PRODUCAO_AGENDADA',
  color: 'green',
  icon: 'fa-clock',
  description: 'Produção Agendada',
  showInFilter: true,
};

export const ERROR_ON_SEND_TO_PRODUCTION = {
  key: 'FALHA_ENVIO_SIPRO',
  color: '#F46036',
  icon: 'fa-exclamation-triangle',
  description: 'Erro ao enviar para produção',
  showInFilter: true,
};

export const DENIED = {
  key: 'CANCELADA',
  color: '#FE4A49',
  icon: 'fa-ban',
  description: 'Cancelada/Recusada',
  showInFilter: true,
};

export const STATUS_PRESCRIPTION_LIST = [
  WAITING_CLIENT,
  WAITING_EMEDE,
  LOCKED,
  WAITING_PHARMACEUTICAL_APPROVE,
  WAITING_TRANSCRIPTION,
  CHECKED_TRANSCRIPTION,
  SCHEDULED_PRODUCTION,
  SENDING_TO_PRODUCTION,
  SENT_TO_PRODUCTION,
  SENT_PARTIAL_TO_PRODUCTION,
  CANCELED_IN_PRODUCTION,
  ERROR_ON_SEND_TO_PRODUCTION,
  DENIED
]

